import styles from './app-nudge.module.css'

type AppNudgeProps = {
  title: string
  body?: string
  buttons?: Array<React.ReactNode>
  image?: React.ReactNode
}

export const AppNudge = ({ title, body, buttons, image }: AppNudgeProps) => (
  <div className={styles.container}>
    <div className={styles.contentContainer}>
      <div className={styles.text}>
        <h2 className={styles.title}>{title}</h2>
        {body && <p className={styles.subtitle}>{body}</p>}
      </div>
      {buttons?.length ? (
        <div className={styles.buttons}>
          {buttons.map((button, index) => (
            <div
              className={styles.buttonItem}
              key={`app-nudge-button-${index}`}
            >
              {button}
            </div>
          ))}
        </div>
      ) : null}
    </div>
    {image && <div className={styles.imageContainer}>{image}</div>}
  </div>
)
